/**
 * The age at which a person stops being a minor: the platform's `minor_age_years` default (ADR 0028). The database
 * reads it from `private.platform_settings`; only DCX can change it there, and nothing a church sees exposes it.
 */
export const MINOR_AGE_YEARS = 18;

/**
 * Whether a person is a minor, by the database's rule (`private.person_is_minor`, ADR 0028), so the drawer offers what
 * the database will serve (#406). A known birthdate decides it, by calendar days: a person is an adult from their 18th
 * birthday on, and someone born on 29 February from 1 March in a year with no 29th. The birthdate is a calendar date
 * ("2008-10-05"), read as that day where the reader is; parsed by `Date` it would be midnight UTC, the evening before
 * in the Americas. With no birthdate, a child in a household is a minor.
 *
 * Today is the reader's day; the database's is UTC's, so the two can differ by a few hours around midnight on an 18th
 * birthday. The database still decides who reads what.
 */
export function isMinor(
  birthdate: string | null,
  householdRoles: readonly string[],
  today: Date = new Date(),
): boolean {
  if (birthdate !== null) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthdate);
    if (match === null) return false;
    const [, year, month, day] = match;
    const comesOfAge = new Date(Number(year) + MINOR_AGE_YEARS, Number(month) - 1, Number(day));
    return new Date(today.getFullYear(), today.getMonth(), today.getDate()) < comesOfAge;
  }
  return householdRoles.includes("child");
}
